import parser from 'url-parse';
import {
    getStepIdAtIndex,
    getStepIndexFromId,
    STEP_ID_CONFIRMATION,
    STEP_ID_DETAILS,
    STEP_ID_PAYMENT,
    STEP_ID_TICKETS,
} from '../components/CheckoutStepper/stepLabels';
import toSearchString from './toSearchString';

export const EVENT_PARAM = 'event';
export const CHECKOUT_STEP_PARAM = 'step';
export const ORDER_TOKEN_PARAM = 'orderToken';
export const PAYMENT_CANCELLED_PARAM = 'paymentCancelled';

export const FIRST_STEP_INDEX = getStepIndexFromId(STEP_ID_TICKETS);
export const DETAILS_STEP_INDEX = getStepIndexFromId(STEP_ID_DETAILS);
export const PAYMENT_STEP_INDEX = getStepIndexFromId(STEP_ID_PAYMENT);
export const CONFIRMATION_STEP_INDEX = getStepIndexFromId(STEP_ID_CONFIRMATION);

export function readStepIndexFromSearch(search) {
    const stepId = new URLSearchParams(search).get(CHECKOUT_STEP_PARAM);
    if (stepId === null) {
        return null;
    }
    return getStepIndexFromId(stepId);
}

export function readPaymentCancelledFromSearch(search) {
    return new URLSearchParams(search).get(PAYMENT_CANCELLED_PARAM) === '1';
}

export function buildStepSearch(search, stepIndex) {
    const params = new URLSearchParams(search);
    const stepId = getStepIdAtIndex(stepIndex);
    if (stepId === null) {
        params.delete(CHECKOUT_STEP_PARAM);
    } else {
        params.set(CHECKOUT_STEP_PARAM, stepId);
    }
    return toSearchString(params);
}

function splitUrl(url) {
    const parsed = parser(url, {});
    const origin = `${parsed.protocol}${parsed.slashes ? '//' : ''}${parsed.host}`;

    return {
        path: `${origin}${parsed.pathname}`,
        query: parsed.query.slice(1),
        fragment: parsed.hash,
    };
}

export function buildLoginUrlForStep(loginUrl, stepIndex) {
    if (!loginUrl || getStepIdAtIndex(stepIndex) === null) {
        return loginUrl;
    }

    const { path, query, fragment } = splitUrl(loginUrl);

    return `${path}${buildStepSearch(query, stepIndex)}${fragment}`;
}

export function appendUrlParam(url, paramName, value) {
    const { path, query, fragment } = splitUrl(url);
    const precedingParams = query.length === 0 ? '' : `${query}&`;

    return `${path}?${precedingParams}${paramName}=${encodeURIComponent(value)}${fragment}`;
}

export function buildSearchWithoutParam(search, paramName) {
    const params = new URLSearchParams(search);
    params.delete(paramName);
    return toSearchString(params);
}

export function resolveLandingStepIndex({
    requestedStepIndex,
    furthestPermittedStepIndex,
    paymentStepSkipped = false,
    lowestPermittedStepIndex = FIRST_STEP_INDEX,
}) {
    if (requestedStepIndex === CONFIRMATION_STEP_INDEX) {
        return CONFIRMATION_STEP_INDEX;
    }
    const requested = requestedStepIndex ?? furthestPermittedStepIndex;
    const permitted = Math.min(requested, furthestPermittedStepIndex);
    const collapsed = paymentStepSkipped && permitted === PAYMENT_STEP_INDEX
        ? DETAILS_STEP_INDEX
        : permitted;
    return Math.max(lowestPermittedStepIndex, collapsed);
}
